/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('AdminServerControllersServiceApi', ($http, ApiErrorService) => {
    return {
        getSimulatorTemplates: getSimulatorTemplates,
        getSimulatorTemplateInfo: getSimulatorTemplateInfo,
        getParamXmlFromSimulatorTemplate: getParamXmlFromSimulatorTemplate,
        createSimulator: createSimulator,
        refreshSimulator: refreshSimulator
    };
    function getSimulatorTemplates(serverControllerId) {
        return $http.get(`api/AdminServerControllers/GetSimulatorTemplates?serverControllerId=${serverControllerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorTemplateInfo(serverControllerId, hostInstallationUid, templateUid, simType) {
        return $http.get(`api/AdminServerControllers/GetSimulatorTemplateInfo?serverControllerId=${serverControllerId}&hostInstallationUid=${encodeURIComponent(hostInstallationUid)}&templateUid=${encodeURIComponent(templateUid)}&simType=${encodeURIComponent(simType)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getParamXmlFromSimulatorTemplate(simTemplate, simType) {
        return $http.post(`api/AdminServerControllers/GetParamXmlFromSimulatorTemplate?simType=${encodeURIComponent(simType)}`, simTemplate)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function createSimulator(serverControllerId, sim) {
        return $http.post(`api/AdminServerControllers/CreateSimulator?serverControllerId=${serverControllerId}`, sim)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function refreshSimulator(simulatorId) {
        return $http.post(`api/AdminServerControllers/RefreshSimulator?simulatorId=${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
